import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { Globals } from "src/app/core/services/global.service";

@Component({
  selector: "app-get-time-based-challenge-details",
  templateUrl: "./get-time-based-challenge-details.component.html",
  styleUrls: [
    "./get-time-based-challenge-details.component.css",
    "../../../offer/pages/offer-creation-simplified/offer-creation-simplified.component.css",
  ],
})
export class GetTimeBasedChallengeDetailsComponent implements OnInit {
  constructor(
    private tokenStorage: TokenStorageService,
    private date_format: getdateformatService,
    private datePipe: DatePipe,
    private global: Globals
  ) {}

  anyTimeSliderValue: boolean = false;
  everyDaySliderValue: boolean = false;
  anyTimeOftheDay: boolean = true;
  specificTime: boolean = false;
  weekDaysChips: any[] = [
    { name: "SUN", selected: false },
    { name: "MON", selected: false },
    { name: "TUE", selected: false },
    { name: "WED", selected: false },
    { name: "THU", selected: false },
    { name: "FRI", selected: false },
    { name: "SAT", selected: false },
  ];
  arrayDynamic = [];
  startDateMinValue;
  endDateMinValue;
  startMaxTime;
  startMinTime;
  endMinTime;
  serviceCountry = sessionStorage.getItem("serviceCountry");
  qid = this.tokenStorage.getqId();
  startDate = new FormControl([Validators.required]);
  endDate = new FormControl([Validators.required]);

  startTime = new FormControl();
  endTime = new FormControl();
  @Input() status;

  ngOnInit(): void {
    this.setDefaultValues();
  }

  getDateFormat(type?) {
    // this.date_format.getDateFormat();
    return this.date_format.getDateFormat(type);
  }

  startDateChange() {
    let startDate = new Date(this.startDate.value);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    let endDate = new Date(this.endDate.value);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMilliseconds(999);
    if (startDate > endDate) {
      this.endDate.setValue(
        new Date(
          this.startDate.value.getFullYear(),
          this.startDate.value.getMonth(),
          this.startDate.value.getDate() + 1,
          23,
          59,
          59,
          999
        )
      );
    }
    let currentDate = new Date(this.startDateMinValue);
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    if (
      startDate.getTime() === currentDate.getTime() &&
      endDate.getTime() === currentDate.getTime()
    ) {
      this.startMinTime = this.addMinutes(
        this.startDateMinValue.toTimeString(),
        60
      );
      this.endMinTime = this.addMinutes(this.startMinTime, 1);
    } else if (
      startDate.getTime() === currentDate.getTime() &&
      endDate.getTime() != currentDate.getTime()
    ) {
      this.startMinTime = this.addMinutes(
        this.startDateMinValue.toTimeString(),
        60
      );
      this.endMinTime = "00:00";
    } else {
      this.startMinTime = "00:00";
      this.endMinTime = "00:01";
    }
    // this.checkStartDateTime();
    this.endDateMinValue = new Date(startDate.toLocaleString("en-US"));
  }

  endDateChange() {
    let startDate = new Date(this.startDate.value);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    let endDate = new Date(this.endDate.value);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMilliseconds(999);
    this.endDate.setValue(endDate);
    if (endDate < startDate) {
      this.startDate.setValue(
        new Date(
          this.endDate.value.getFullYear(),
          this.endDate.value.getMonth(),
          this.endDate.value.getDate() - 1,
          0,
          0,
          0,
          0
        )
      );
    }
    let currentDate = new Date(this.startDateMinValue);
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    if (endDate.getTime() === currentDate.getTime()) {
      this.endMinTime = this.addMinutes(this.startMinTime, 1);
    } else if (endDate.getTime() != currentDate.getTime()) {
      this.endMinTime = "00:00";
    }
    // this.checkStartDateTime();
  }

  checkIfBeforeCurrentDate(date) {
    const options = { timeZone: this.tokenStorage.getMerchantTimeZone() };
    const today = new Date();
    const todayInTimezone = today.toLocaleString("en-US", options);
    const todayInTimezoneDate = new Date(todayInTimezone);
    // Extract only the date part (year, month, and day)
    const year = todayInTimezoneDate.getFullYear();
    const month = todayInTimezoneDate.getMonth() + 1; // Month is zero-indexed, so add 1
    const day = todayInTimezoneDate.getDate();

    // Create a new Date object with only the date (time will be set to midnight)
    const todayWithoutTime = new Date(year, month - 1, day);
    // const todayWithoutTime = new Date(Date.UTC(year, month - 1, day));

    // Convert to specific timezone

    // If you need it as a Date object

    // Assuming you have the selected date in a variable called selectedDate
    const selectedDate = new Date(date); // Replace this with your selected date

    // Check if the selected date is before today's date
    if (selectedDate < todayWithoutTime) {
      return true;
    } else if (selectedDate > todayWithoutTime) {
      return false;
    } else {
      return false;
    }
  }
  startTimeChange() {
    let currentTime = new Date();
    let startTime = new Date(this.startDate.value);
    startTime.setHours(
      +this.transformTo24HourFormat(this.startTime.value).split(":")[0]
    );
    startTime.setMinutes(
      +this.transformTo24HourFormat(this.startTime.value).split(":")[1]
    );
    startTime.setSeconds(0);
    startTime.setMilliseconds(0);
    let endTime = new Date(this.endDate.value);
    endTime.setHours(
      +this.transformTo24HourFormat(this.endTime.value).split(":")[0]
    );
    endTime.setMinutes(
      +this.transformTo24HourFormat(this.endTime.value).split(":")[1]
    );
    endTime.setSeconds(0);
    endTime.setMilliseconds(0);
    if (endTime <= startTime) {
      let hour: any = +this.transformTo24HourFormat(this.startTime.value).split(
        ":"
      )[0];
      let minute: any = +this.transformTo24HourFormat(
        this.startTime.value
      ).split(":")[1];
      if (minute === 59) {
        minute = "00";
        hour += 1;
      } else {
        minute += 1;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      this.endTime.setValue(
        this.transformTo12HourFormat(
          hour +
            ":" +
            (minute < 10 && minute > 0 ? "0" + minute : minute.toString())
        )
      );
      //this.endMinTime=this.endTime.value;
    }
  }

  endTimeChange() {
    let currentTime = new Date();
    let startTime = new Date(this.startDate.value);
    startTime.setHours(
      +this.transformTo24HourFormat(this.startTime.value).split(":")[0]
    );
    startTime.setMinutes(
      +this.transformTo24HourFormat(this.startTime.value).split(":")[1]
    );
    startTime.setSeconds(0);
    startTime.setMilliseconds(0);
    let endTime = new Date(this.endDate.value);
    endTime.setHours(
      +this.transformTo24HourFormat(this.endTime.value).split(":")[0]
    );
    endTime.setMinutes(
      +this.transformTo24HourFormat(this.endTime.value).split(":")[1]
    );
    endTime.setSeconds(0);
    endTime.setMilliseconds(0);
    if (endTime <= startTime) {
      let hour: any = +this.transformTo24HourFormat(this.endTime.value).split(
        ":"
      )[0];
      let minute: any = +this.transformTo24HourFormat(this.endTime.value).split(
        ":"
      )[1];
      if (minute === 0) {
        minute = "59";
        hour -= 1;
      } else {
        minute -= 1;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      this.startTime.setValue(
        this.transformTo12HourFormat(
          hour +
            ":" +
            (minute < 10 && minute > 0 ? "0" + minute : minute.toString())
        )
      );
    }
  }

  transformTo24HourFormat(time12hr: string): string {
    if (sessionStorage.getItem("serviceCountry") === "US") {
      // Use the DatePipe to format the time in 12-hour format
      let formattedTime = time12hr;

      // Parse the formatted time to get the hour and minute
      let parts = formattedTime.split(":");
      let hour = parseInt(parts[0], 10);
      let minute = parseInt(parts[1], 10);

      // Check if it's PM, and if it is, add 12 to the hour
      if (time12hr.toLowerCase().includes("pm") && hour < 12) {
        hour += 12;
      } else if (time12hr.toLowerCase().includes("am") && hour == 12) {
        hour = 0;
      }

      // Format the hour and minute as two-digit strings
      let hourStr = hour.toString().padStart(2, "0");
      let minuteStr = minute.toString().padStart(2, "0");

      // Return the time in 24-hour format
      return `${hourStr}:${minuteStr}`;
    } else {
      return time12hr;
    }
  }
  transformTo12HourFormat(time24hr: string): string {
    // Split the time string into hours and minutes
    if (sessionStorage.getItem("serviceCountry") === "US") {
      const [hoursStr, minutesStr] = time24hr.split(":");
      const hours = parseInt(hoursStr, 10);
      const minutes = parseInt(minutesStr, 10);

      // Determine AM or PM based on hours
      const period = hours >= 12 ? "PM" : "AM";

      // Convert hours to 12-hour format
      const hours12 = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;

      // Format the time in 12-hour format
      const formattedTime = `${hours12}:${minutes
        .toString()
        .padStart(2, "0")} ${period}`;

      return formattedTime;
    } else {
      return time24hr;
    }
  }

  addMinutes(time, minsToAdd) {
    var piece = time.split(":");

    var mins = piece[0] * 60 + +piece[1] + +minsToAdd;

    return this.D(((mins % (24 * 60)) / 60) | 0) + ":" + this.D(mins % 60);
  }

  D(J) {
    return (J < 10 ? "0" : "") + J;
  }

  toTimeFormat(time) {
    return this.datePipe.transform(time, "yyyy-MM-dd HH:mm:ss");
  }

  toMerchantTimeZome(utcDate) {
    return this.datePipe.transform(utcDate, "yyyy-MM-dd HH:mm:ss");
  }

  toggleSelection(day: any) {
    day.selected = !day.selected;
    this.arrayDynamic = [];
    for (let day of this.weekDaysChips) {
      if (day.selected) {
        this.arrayDynamic.push(day.name);
      }
    }
  }

  setDefaultValues() {
    let currentDate = new Date();
    this.startDateMinValue = new Date(
      currentDate.toLocaleString("en-US", {
        timeZone: this.tokenStorage.getMerchantTimeZone(),
      })
    );
    let hh = this.startDateMinValue.getHours();
    let mm = this.startDateMinValue.getMinutes();
    // Increment hour and minute properly, handling overflow
    hh = (hh + 1) % 24; // Ensure hours wrap around correctly
    let mmIncremented = (mm + 1) % 60; // Increment minutes and wrap around

    // Format hours and minutes
    hh = hh < 10 ? "0" + hh : hh;
    mm = mm < 10 ? "0" + mm : mm;
    let endhh = hh;
    let endmm = mmIncremented < 10 ? "0" + mmIncremented : mmIncremented;

    // Adjust hour if minute overflowed
    if (mmIncremented === 0) {
      endhh = (parseInt(endhh) + 1) % 24;
      endhh = endhh < 10 ? "0" + endhh : endhh;
    }

    this.startTime.setValue(`${hh}:${mm}`);
    this.endTime.setValue(`${endhh}:${endmm}`);
    this.endDateMinValue = new Date(
      currentDate.toLocaleString("en-US", {
        timeZone: this.tokenStorage.getMerchantTimeZone(),
      })
    );
    this.endDateMinValue.setHours(0, 0, 0, 0);
    this.startMaxTime = "23:58";

    this.startMinTime = this.addMinutes(
      this.startDateMinValue.toTimeString(),
      60
    );
    // this.endMinTime = this.addMinutes(this.startMinTime, 1);
    let startDate = new Date(this.startDate.value);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    let endDate = new Date(this.endDate.value);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMilliseconds(999);
    if (
      startDate.getTime() === currentDate.getTime() &&
      endDate.getTime() === currentDate.getTime()
    ) {
      this.startMinTime = this.addMinutes(
        this.startDateMinValue.toTimeString(),
        60
      );
      this.endMinTime = this.addMinutes(this.startMinTime, 1);
    } else {
      this.endMinTime = "00:01";
    }
    //this.startDate.setValue(this.startDateMinValue);
    const merchantMidnight = new Date(this.startDateMinValue);
    merchantMidnight.setHours(0, 0, 0, 0);
    this.startDate.setValue(merchantMidnight);

    this.endDateMinValue.setDate(this.startDateMinValue.getDate());
    this.endDate.setValue(
      new Date(
        this.startDateMinValue.getFullYear(),
        this.startDateMinValue.getMonth() + 1,
        0,
        23,
        59,
        59,
        999
      )
    );
  }

  onSpecificTimeChange(event) {
    this.specificTime = event;
    this.anyTimeOftheDay = !event;
  }

  onAnyTimeOftheDayChange(event) {
    this.specificTime = !event;
    this.anyTimeOftheDay = event;
  }
}
